export const API_RESONSE_SUCCESS = "SUCCESS";
export const API_RESONSE_FAILED = "Something went wrong please try again later";
export const VERIFICATION_TYPE_MOBILE = "mobile";
export const VERIFICATION_TYPE_EMAIL = "email";
export const SALE_DATE_NOT_STARTED =
  "Ticket booking is not started yet. Plese try after ";
export const SALE_END_DATE_REACHED =
  "Ticket booking date are passed. Please cehck out another event.";
